import loadable from '@loadable/component';
import { getLogger } from '@cian/logger/shared';

export const FloorPlanLoadable = loadable(() =>
  import('./FloorPlan').catch(error => {
    getLogger().error(error, { domain: 'FloorPlanLoadable' });

    return { default: () => null };
  }),
);
